import FormattedDateTime from '../formatting/FormattedDateTime';
import React from 'react';

export default function VesselEta({ value }) {
	return <div style={{ display: 'inline-block', whiteSpace: 'nowrap', borderRadius: '4px', background: 'var(--col-primary-200)', color: 'var(--col-gray-800)', padding: '4px 8px' }}>
		<span className="fa fa-calendar-o" />&nbsp;&nbsp;<FormattedDateTime value={value} />
	</div>;
}